import React from 'react';

import { Provider, CachePolicies, Interceptors } from 'use-http';
import { useSelector } from 'react-redux';
import { IRootState } from 'src/reducers';

const ApiProvider: React.FC = (props) => {
    let headers = {};
    let baseUrl = '';

    const jwt = useSelector((state: IRootState) => state.auth.user.jwt);

    if (jwt) {
        headers = {
            contentType: 'application/json',
            Authorization: `Bearer ${jwt}`,
        };
    } else {
        headers = {
            contentType: 'application/json',
        };
    }

    baseUrl = process.env.REACT_APP_BASE_API_URL;

    const interceptors: Interceptors = {
        request: ({ options, url, path, route }) => {
            localStorage.setItem('lastApiCall', `${url}${route}`);
            localStorage.setItem('lastApiBody', JSON.stringify(options.body, null, 2));
            return options;
        },
    };

    return (
        <Provider url={baseUrl} options={{ headers, cachePolicy: CachePolicies.NO_CACHE, interceptors }}>
            {props.children}
        </Provider>
    );
};

export default ApiProvider;



// WEBPACK FOOTER //
// ./src/providers/ApiProvider.tsx